<template>
	<div>
		<mobile v-if='isMobile'></mobile>
		<mess v-else></mess>
	</div>
</template>

<script>
	import mess from './content/mess'
	import mobile from './content/mobile'
	import util from 'Common/util';
	export default {
		name: 'app',
		components: {
			mess,
			mobile
		},
		data(){
			return {
				isMobile:true
			}
		},
		mounted() {
			const that = this
			that.changeType()
      window.addEventListener('resize', util.debounce(that.changeType,1000))
		},
		methods: {
			changeType() {
        const that = this
        if (document.documentElement.clientWidth < 960) {
          that.isMobile = true
        } else {
          that.isMobile = false
        }
      },
		},
	}
</script>


// WEBPACK FOOTER //
// src/views/pages/home/app.vue